<template>
  <div>
    <b-table
      ref="table"
      responsive="sm"
      striped
      hover
      selectable
      select-mode="single"
      @row-selected="onRowSelected"
      :items="deviceGroupList"
      :fields="fields"
      :small="true"
      :no-provider-paging="true"
      :no-provider-filtering="true"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      @filtered="onFiltered"
      :sort-by="'id'"
      :empty-text="this.$t('select_and_tables.empty')"
      :empty-filtered-text="this.$t('select_and_tables.empty_filtered')"
      show-empty
    >
    <template v-slot:cell(name)="data">
       <t-badge :background="data.item.color">{{ data.item.name }}</t-badge>
    </template>
    <template v-slot:cell(deviceCount)="data">
        <b-badge pill variant="warning">{{ data.item.devices.length }}</b-badge>
    </template>
    </b-table>

    <TablePagination
      :total-rows="totalRows"
      :per-page="perPage"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import deviceGroup from '@/store/displays/deviceGroup'

export default {
  props: {
    filter: String,
  },
  data: function () {
    return {
      perPage: 15,
      currentPage: 1,
      filteredRows: 1,
    }
  },
  watch: {
    item() {
      if (!this.item) this.$refs.table.clearSelected()
    },
  },
  computed: {
    deviceGroupList() {
      return this.$store.state.deviceGroup.deviceGroupList
    },
    fields() {
      return [
        { key: 'name', label: this.$t('device_groups.name'), sortable: true },
        { key: 'description', label: this.$t('device_groups.description'), sortable: true },
        { key: 'color', label: this.$t('device_groups.color'), sortable: true },
        { key: 'deviceCount', label: this.$t('device_groups.count'), sortable: true }
      ]
    },
    totalRows() {
      if (!this.filter) {
        return this.deviceGroupList.length
      }
      return this.filteredRows
    },
  },
  beforeCreate: function () {
    if (!this.$store.state.deviceGroup) {
      this.$store.registerModule('deviceGroup', deviceGroup)
    }
    this.$store.dispatch('deviceGroup/getDeviceGroupList')
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length
      this.currentPage = 1
      this.$emit('selectItem', null)
    },
    onRowSelected(items) {
      if (items[0]) this.$emit('selectItem', items[0])
    }
  },
}
</script>
